/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Add_Mesh_RequiredInputs */



/**
* | output |
* | --- |
* | "Select at least one network" |
*
* @param {Gateway_Add_Mesh_RequiredInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const gateway_add_mesh_required = /** @type {((inputs?: Gateway_Add_Mesh_RequiredInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Add_Mesh_RequiredInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Select at least one network")
	return /** @type {LocalizedString} */ ("Sélectionnez au moins un ")
});